import { Search, Filter, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from './button'

type SearchBarProps = {
  placeholder?: string
  onSearch?: (value: string) => void
  onFilterClick?: () => void
  initialValue?: string
}

const SearchBar = ({ placeholder = 'Search services, categories...', onSearch, onFilterClick, initialValue = '' }: SearchBarProps) => {
  const [value, setValue] = useState(initialValue)

  return (
    <div className="flex items-center gap-2 bg-background border border-input rounded-2xl px-3 py-1.5 shadow-sm transition-colors focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/30">
      <Search className="size-5 text-muted-foreground" />
      <input
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
          onSearch?.(e.target.value)
        }}
        placeholder={placeholder}
        className="flex-1 bg-transparent outline-none placeholder:text-muted-foreground text-foreground"
      />
      {value && (
        <button
          aria-label="Clear"
          onClick={() => { setValue(''); onSearch?.('') }}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="size-5" />
        </button>
      )}
      <div className="h-5 w-px bg-border" />
      <Button size="sm" onClick={onFilterClick}>
        <Filter className="size-4" />
        Filters
      </Button>
    </div>
  )
}

export default SearchBar
